/* eslint-disable no-script-url */
import { Link } from 'react-router-dom';

import loginImg from  "./Images/loginImg.jpg";
import $ from 'jquery';

function LoginPage(){
    $('#username').removeClass('is-valid').removeClass('is-invalid')
    $('#password').removeClass('is-valid').removeClass('is-invalid')
    var form = document.getElementById("form");
    const formValidate = (event)=> {
        event.preventDefault();
        var name = $('#username').val();
        var pwd = $('#password').val();
        if(name === ""){
            $('#username').removeClass('is-valid').addClass('is-invalid');
        }else{
            $('#username').removeClass('is-invalid').addClass('is-valid');
        }
            
        if(pwd === ""){
            $('#password').removeClass('is-valid').addClass('is-invalid');
        }else{
            $('#password').removeClass('is-invalid').addClass('is-valid');
        }
        if(name !== "" && pwd !== ""){
            alert("values entered")
            form.action = "/";
            form.method = "get";
            // form.addEventListener("submit", function(event) {
                form.submit();
            // });
        }
    }
    return(
        <>
            <div className="container-fluid mt-5 mb-5">
                <div className="row">
                    <div className="col-10 offset-md-1 border border-dark contactCardColor mb-5">
                        <div className="row">
                            <div className="col-lg-6 p-0">
                                <img src={loginImg} alt="" className="w-100 h-100 mb-0"/>
                            </div>
                            <div className="col-lg-6 p-5">
                                <div className="fs-1 mb-3 fw-bold headingCls">
                                    SIGN IN 
                                    <a href="https://twitter.com/stanford" className="footerLinks float-end"><i className="fa-brands fa-twitter fs-1 me-2 text-primary px-2"></i></a>
                                    <a href="https://www.facebook.com/stanford" className="footerLinks float-end"><i className="fa-brands fa-facebook fs-1 me-2 text-black"></i></a>
                                </div>
                                <form id="form" onSubmit={formValidate}>
                                    <div className="mb-3">
                                        <label htmlFor="username" className="form-label fw-bold">USERNAME</label>
                                        <input type="text" className="form-control fw-bold form-control-lg" id="username"/>
                                        <div className="invalid-feedback aboutText">
                                            This field is required!
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="password" className="form-label fw-bold">PASSWORD</label>
                                        <input type="password" className="form-control fw-bold form-control-lg" id="password"/>
                                        <div className="invalid-feedback aboutText">
                                            This field is required!
                                        </div>
                                    </div>
                                    <div className="text-center my-3">
                                        <input type="submit" value="Submit" className="linkCls btn-block btn-lg fs-5 text-center"/>
                                    </div>
                                    <div className="mb-3 form-check">
                                        <input type="checkbox" className="form-check-input" id="checkbox"/>
                                        <label className="form-check-label fw-bold" htmlFor="checkbox">Remember Me</label>
                                        <div className="float-end fw-bold headingCls">Forgot Password?</div>
                                    </div>
                                    <div className="text-center mt-4 fw-bold headingCls">
                                        Not a member? <Link to="/register" className="text-decoration-none text-success fs-5">Sign Up</Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </>
    )
}export default LoginPage